/**
 * Prefer the free-text `title` (e.g. "Head of Talent Acquisition") as the
 * human-readable sub-label beneath an agent's name. Fall back to the
 * capitalised `role` enum ("ic", "manager") so agents created before titles
 * were set don't render with a blank subtitle.
 */
export function agentRoleLabel(agent: {
  title?: string | null;
  role?: string | null;
}): string {
  if (agent.title && agent.title.trim().length > 0) return agent.title;
  const role = agent.role ?? "";
  if (!role) return "";
  return role.charAt(0).toUpperCase() + role.slice(1);
}
